export default __webpack_public_path__ + "static/media/ico_login.22cd0e77.svg";